const useFileHelper = () => {
    const getBase64 = (file) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise((resolve) => {
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function () {
                resolve(reader.result);
            };
        })
  
    }

    return [getBase64];
}

export default useFileHelper;